import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

interface FilterPaymentTypeProps {
  control: any;
  errors: any;
}

const OPTIONS = [
  { value: "0", label: "Todos" },
  { value: "7", label: "Cartão de crédito" },
  { value: "6", label: "Cartão de débito" },
  { value: "10", label: "CLUB+" },
  { value: "pix", label: "Carteira Digital" },
];

export function FilterPaymentType({ control }: FilterPaymentTypeProps) {
  return (
    <FormField
      control={control}
      name="paymentType"
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel className="block text-sm font-medium text-gray-700">
            Tipo de Pagamento *
          </FormLabel>
          <FormControl>
            <Select value={field.value} onValueChange={field.onChange}>
              <SelectTrigger className="flex items-center w-full h-[50px] px-4 py-2 border rounded-lg text-left text-gray-700 shadow-sm">
                <SelectValue placeholder="Selecione o tipo" />
              </SelectTrigger>
              <SelectContent className="w-[--radix-select-trigger-width]">
                {OPTIONS.map((opt) => (
                  <SelectItem
                    key={opt.value}
                    value={opt.value}
                    className="text-gray-700"
                  >
                    {opt.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}